/*
 * FarmSteady — PLP quick add (snippets/fs-collection-card.liquid).
 * One fetch to /cart/add.js (same headers Dawn's product-form uses); the
 * ReBuy Smart Cart intercepts cart adds and opens itself, and the Shopify
 * Google channel pixel records add_to_cart for AJAX adds (verified on the
 * drawer "+" 2026-08-18). Button shows adding → Added for ~1.6s.
 */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-fs-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.state === 'adding') return;
    var id = btn.getAttribute('data-fs-quick-add');
    var label = btn.textContent;
    btn.dataset.state = 'adding';
    btn.textContent = 'Adding…';
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) throw new Error(res.description || 'add failed');
        btn.dataset.state = 'added';
        btn.textContent = 'Added ✓';
        try { document.dispatchEvent(new CustomEvent('fs:quick-add', { detail: { variantId: id, item: res } })); } catch (err) {}
        setTimeout(function () { btn.dataset.state = ''; btn.textContent = label; }, 1600);
      })
      .catch(function () {
        btn.dataset.state = '';
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = label; }, 1600);
      });
  });
})();
